import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  inject,
  CUSTOM_ELEMENTS_SCHEMA,
  ViewChild,
} from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  FormsModule,
  Validators,
} from '@angular/forms';
import { MaterialModule } from '../../../shared/material/material.module';
import { ProductTypeEnumDescription } from '../../../shared/enums';
import {
  ProfileProviderPjControllerService,
  ProfileProviderPJ,
  ProviderPJUser,
  UserRef,
  Address,
} from '../../../core/generated';
import { MatDialog } from '@angular/material/dialog';
import { DialogCNESFinderComponent } from '../../../shared/dialogs/dialog-cnes-finder/dialog-cnes-finder.component';
import { CNES } from '../../../shared/dialogs/dialog-cnes-finder/cnes-finder.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute, Router } from '@angular/router';
import { MatTable } from '@angular/material/table';
import { DialogAddUserComponent } from '../../../shared/dialogs/dialog-add-user/dialog-add-user.component';
import { AttachmentComponent } from '../../../shared/attachment/attachment.component';
import { register, SwiperContainer } from 'swiper/element';
import { DeviceDetectorService } from 'ngx-device-detector';
import { UserPreferencesCacheService } from '../../../shared/services/user-preferences-cache.service';
import { isValidCNPJ, isValidCNPJFormat } from '../../../shared/utils/validators';
import { AddressDialogComponent } from '../../../shared/address-dialog/address-dialog.component';
import { AddressListComponent } from '../../../shared/address-list/address-list.component';
import { CertificationButtonComponent } from '../../../shared/certification-button/certification-button.component';
import { EnumDescriptionPipe } from '../../../shared/pipes/enum-description.pipe';
import { firstValueFrom } from 'rxjs';
import { ProfileProviderPJStateService } from '../../../shared/services/profile-provider-pj-state.service';
import { PlanStatusService } from '../../../shared/services/plan-status-cache.service';
import { EncryptionUtil } from '../../../shared/utils/encryption.util';
import { take } from 'rxjs/operators';
import { ContainerComponent } from '../../../shared/container/container.component';

register();

@Component({
    selector: 'app-profile-provider-pj',
    standalone: true,
    imports: [MaterialModule, AttachmentComponent, FormsModule, AddressListComponent, CertificationButtonComponent, EnumDescriptionPipe, ContainerComponent],
    templateUrl: './profile-provider-pj.component.html',
    styleUrl: './profile-provider-pj.component.scss',
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class ProfileProviderPJComponent {
  private fb = inject(FormBuilder);
  private profileProviderPJService = inject(ProfileProviderPjControllerService);
  private profileProviderPJStateService = inject(ProfileProviderPJStateService);
  private planStatusService = inject(PlanStatusService);
  public dialog = inject(MatDialog);
  private router = inject(Router);
  private routes = inject(ActivatedRoute);
  private cd = inject(ChangeDetectorRef);
  private deviceService = inject(DeviceDetectorService);
  private UserPreferencesCacheService = inject(UserPreferencesCacheService);
  private cdr = inject(ChangeDetectorRef);

  selectedTab = new FormControl('');
  @ViewChild('swiper') swiperRef!: ElementRef<SwiperContainer>;
  @ViewChild(MatTable) table!: MatTable<ProfileProviderPJ>;
  user: UserRef | undefined;
  providerPJ!: ProfileProviderPJ;
  providerPJUser!: ProviderPJUser[];
  providerPJForm!: FormGroup;
  private _snackBar = inject(MatSnackBar);
  isEditMode: boolean = false;
  districts = [
    { code: 'AC', description: 'Acre' },
    { code: 'AL', description: 'Alagoas' },
    { code: 'AP', description: 'Amapá' },
    { code: 'AM', description: 'Amazonas' },
    { code: 'BA', description: 'Bahia' },
    { code: 'CE', description: 'Ceará' },
    { code: 'DF', description: 'Distrito Federal' },
    { code: 'ES', description: 'Espírito Santo' },
    { code: 'GO', description: 'Goiás' },
    { code: 'MA', description: 'Maranhão' },
    { code: 'MT', description: 'Mato Grosso' },
    { code: 'MS', description: 'Mato Grosso do Sul' },
    { code: 'MG', description: 'Minas Gerais' },
    { code: 'PA', description: 'Pará' },
    { code: 'PB', description: 'Paraíba' },
    { code: 'PR', description: 'Paraná' },
    { code: 'PE', description: 'Pernambuco' },
    { code: 'PI', description: 'Piauí' },
    { code: 'RJ', description: 'Rio de Janeiro' },
    { code: 'RN', description: 'Rio Grande do Norte' },
    { code: 'RS', description: 'Rio Grande do Sul' },
    { code: 'RO', description: 'Rondônia' },
    { code: 'RR', description: 'Roraima' },
    { code: 'SC', description: 'Santa Catarina' },
    { code: 'SP', description: 'São Paulo' },
    { code: 'SE', description: 'Sergipe' },
    { code: 'TO', description: 'Tocantins' }
  ];
  businessTypes = [
    { code: 'HOSPITAL', description: 'Hospital' },
    { code: 'CLINICA', description: 'Clínica' },
    { code: 'HOMECARE', description: 'Home Care' },
    { code: 'DIAGNOSTICO', description: 'Diagnóstico' },
    { code: 'HOSPITALDIA', description: 'Hospital Dia' },
    { code: 'LABORATORIO', description: 'Laboratório' },
    { code: 'PRONTOATENDIMENTO', description: 'Pronto Atendimento' },
    { code: 'OPERADORA', description: 'Operadora' },
    { code: 'ADMINISTRADORHOSPITALAR', description: 'Administrador Hospitalar' }
  ];
  payerCnpj = '';
  productPackageType: string | null = null;
  documentTypesRequired: string[] = [
    "Alvará de Localização",
    "Alvará da Vigilância Sanitária",
    "Cartão CNPJ",
    "Número de registro no CNES",
    "Alvará de Prevenção e Proteção Contra Incêndios (Protocolo)",
    "Registro da empresa no Conselho Profissional",
    "Registro profissional RT no Conselho Profissional",
    "Contrato Social da Empresa / Estatuto Social"
  ];
  documentTypesRequiredContractor: string[] = [
    "Cartão CNPJ",
    "Contrato Social da Empresa / Estatuto Social"
  ];
  isMobile = this.deviceService.isMobile();

  addresses: Address[] = [];
  selectedAddressId: number | null = null;
  isLoading = true;
  private readonly providerOnlyControls = [
    'businessType',
    'cnesCode',
    'crmTechnicalNumber',
    'businesLicenseControlNumber',
    'pumblerLicenseControlNumber',
  ] as const;

  async ngOnInit() {
    this.isLoading = true;
    try {
      this.user = await firstValueFrom(this.UserPreferencesCacheService.getUser().pipe(take(1)));

      this.providerPJForm = this.fb.group({
        id: [null],
        profile: [null],
        cnesCode: [{ value: '', disabled: true }],
        companyName: [{ value: '', disabled: true }, Validators.required],
        companyMarketingName: [{ value: '', disabled: true }, Validators.required,],
        cnpj: [{ value: '', disabled: true }, [Validators.required, Validators.pattern(/^\d{14}$/), this.validateCNPJ]],
        phoneNumber: [{ value: '', disabled: true }, Validators.required],
        crmTechnicalNumber: [{ value: '', disabled: true }],
        businesLicenseControlNumber: [{ value: '', disabled: true }],
        pumblerLicenseControlNumber: [{ value: '', disabled: true }],
        businessType: [{ value: '', disabled: true }],
        email: [{ value: '', disabled: true }, [Validators.required, Validators.email]],
        registerDate: [{ value: '', disabled: true }],
        status: [{ value: '', disabled: true }],
        certifiedHubMedical: [{ value: true, disabled: true }],
        active: [{ value: true, disabled: true }],
      });

      const routeId = this.routes.snapshot.paramMap.get('id');

      if (!routeId) {
        const params = await firstValueFrom(this.routes.queryParams.pipe(take(1)));
        if (params['pkg']) {
          const decryptedPackage = EncryptionUtil.decrypt(params['pkg']);
          if (decryptedPackage) {
            this.productPackageType = decryptedPackage;
            this.syncProfileFromPackageType();
          } else {
            console.warn('Parâmetro packageType inválido ou manipulado');
            this.router.navigate(['/my-account/profiles/select-new-profile']);
            return;
          }
        } else {
          this.router.navigate(['/my-account/profiles/select-new-profile']);
          return;
        }
      }

      await this.loadProviderPJForm();

      this.applyProviderFieldRules();

      this.selectedTab.setValue('tab1');
    } finally {
      this.isLoading = false;
      this.cd.detectChanges();
    }
  }

  ngAfterViewInit() {
    this.initializeSwiperWithRetry();
  }

  private initializeSwiperWithRetry(attempts = 0, maxAttempts = 10) {
    setTimeout(() => {
      const swiperInstance = this.swiperRef?.nativeElement?.swiper;
      
      if (swiperInstance) {
        this.setupSwiperListeners(swiperInstance);
      } else {
        if (attempts < maxAttempts) {
          this.initializeSwiperWithRetry(attempts + 1, maxAttempts);
        }
      }
    }, 200 * (attempts + 1));
  }

  private setupSwiperListeners(swiperInstance: any) {
    this.selectedTab.valueChanges.subscribe((value) => {
      if (!this.providerPJForm?.controls?.['id']?.value && value !== 'tab1') {
        this.selectedTab.setValue('tab1', { emitEvent: false });
        swiperInstance.slideTo(0);
        return;
      }

      const index = ({
        tab1: 0,
        tab2: 1,
        tab3: 2,
        tab4: 3,
        tab5: 4,
      } as Record<string, number>)[value ?? 'tab1'];

      if (typeof index === 'number' && swiperInstance.activeIndex !== index) {
        swiperInstance.slideTo(index);
      }
    });

    swiperInstance.on('slideChange', () => {
      const idx = swiperInstance.activeIndex;
      const tabValue = ['tab1', 'tab2', 'tab3', 'tab4', 'tab5'][idx] || 'tab1';

      if (!this.providerPJForm?.controls?.['id']?.value && tabValue !== 'tab1') {
        this.selectedTab.setValue('tab1', { emitEvent: false });
        swiperInstance.slideTo(0);
      } else {
        if (this.selectedTab.value !== tabValue) {
          this.selectedTab.setValue(tabValue, { emitEvent: false });
          this.cdr.detectChanges();
        }
      }
    });
  }

  findCNES() {
    const dialogRef = this.dialog.open(DialogCNESFinderComponent, {
      data: { cns: 123456 },
    });

    dialogRef.afterClosed().subscribe();
  }

  async loadProviderPJForm() {
    if (this.providerPJ) {
      this.providerPJForm.patchValue(this.providerPJ);
    } else {
      let id: any = this.routes.snapshot.paramMap.get('id');
      if (id) {
        this.providerPJ = await firstValueFrom(this.profileProviderPJService
          .findById6(Number(id)))
        this.providerPJForm.patchValue(this.providerPJ);
        this.addresses = this.providerPJ.addresses || [];
      } else {
        this.editMode(true);
      }
    }
  }

  async saveProfileProviderPJ() {
    const cnpjValue = this.providerPJForm.controls['cnpj'].value;
    if (!cnpjValue || !isValidCNPJ(cnpjValue)) {
      this._snackBar.open('CNPJ é obrigatório e deve ser válido', '', {
        duration: 3000,
      });
      this.editMode(true);
      return;
    }

    if (this.providerPJForm.valid) {
      let payload = { ...this.providerPJForm.value };

      if (payload.profile === 'CONTRACTOR_PJ') {
        delete payload.cnesCode;
        delete payload.crmTechnicalNumber;
        delete payload.businessType;
        delete payload.pumblerLicenseControlNumber;
        delete payload.businesLicenseControlNumber;
      }

      if (this.providerPJForm.controls['id'].value == null) {
        await this.profileProviderPJService
          .save5(
            this.productPackageType as 'SUBSCRIPTION_PROVIDER_PF_FREE' | 'SUBSCRIPTION_PROVIDER_PF_BASIC' | 'SUBSCRIPTION_LAB_FREE' | 'SUBSCRIPTION_LAB_BASIC' | 'SUBSCRIPTION_PROVIDER_PJ_FREE' | 'SUBSCRIPTION_PROVIDER_PJ_2' | 'SUBSCRIPTION_PROVIDER_PJ_6' | 'SUBSCRIPTION_PROVIDER_PJ_10' | 'SUBSCRIPTION_PROVIDER_PJ_PERSONAL' | 'SUBSCRIPTION_PROVIDER_CONTRACTOR_PJ_FREE' | 'SUBSCRIPTION_PROVIDER_CONTRACTOR_PJ_100' | 'SUBSCRIPTION_PROVIDER_CONTRACTOR_PJ_PERSONAL' | 'SUBSCRIPTION_CONTRACTOR_PJ_120' | 'SUBSCRIPTION_CONTRACTOR_PJ_PERSONAL' | 'SUBSCRIPTION_ADMINISTRATOR',
            payload,
            this.payerCnpj
          )
          .subscribe({
            next: async (response) => {
              this.providerPJForm.patchValue(response);
              this.profileProviderPJStateService.addProfile(response);

              if (response.cnpj) {
                await this.planStatusService.refresh();
              }

              this.router.navigate(['/my-account/profiles/profileProviderPJForm/' + response.id]);
              this.editMode(false);
            }
          });
      } else {
        await this.profileProviderPJService
          .update5(
            this.providerPJForm.value.id,
            payload
          )
          .subscribe({
            next: (response) => {
              this.providerPJForm.patchValue(response);
              this.profileProviderPJStateService.updateProfile(response);
              this.editMode(false);
            }
          });
      }
    } else {
      this._snackBar.open('Preencha todos os campos obrigatórios corretamente', '', {
        duration: 3000,
      });
      this.editMode(true);
    }
  }

  editMode(editMode: boolean) {
    this.isEditMode = editMode;
    if (editMode) {
      if (this.isProvider()) {
        this.providerPJForm.controls['cnesCode'].enable();
        this.providerPJForm.controls['businesLicenseControlNumber'].enable();
        this.providerPJForm.controls['pumblerLicenseControlNumber'].enable();
        this.providerPJForm.controls['crmTechnicalNumber'].enable();
        this.providerPJForm.controls['businessType'].enable();
      }
      if (!isValidCNPJ(this.providerPJForm.controls['cnpj'].value)) {
        this.providerPJForm.controls['cnpj'].enable();
      }
      this.providerPJForm.controls['companyName'].enable();
      this.providerPJForm.controls['companyMarketingName'].enable();
      this.providerPJForm.controls['phoneNumber'].enable();
      this.providerPJForm.controls['email'].enable();
    } else {
      this.providerPJForm.controls['cnesCode'].disable();
      this.providerPJForm.controls['cnpj'].disable();
      this.providerPJForm.controls['companyName'].disable();
      this.providerPJForm.controls['companyMarketingName'].disable();
      this.providerPJForm.controls['businesLicenseControlNumber'].disable();
      this.providerPJForm.controls['pumblerLicenseControlNumber'].disable();
      this.providerPJForm.controls['phoneNumber'].disable();
      this.providerPJForm.controls['crmTechnicalNumber'].disable();
      this.providerPJForm.controls['email'].disable();
      this.providerPJForm.controls['businessType'].disable();
    }
  }

  private applyProviderFieldRules() {
    const isProvider = this.isProvider();

    for (const controlName of this.providerOnlyControls) {
      const control = this.providerPJForm.get(controlName);
      if (!control) continue;

      if (isProvider) {
        control.setValidators([Validators.required]);
      } else {
        control.clearValidators();
        control.disable({ emitEvent: false });
      }
      control.updateValueAndValidity({ emitEvent: false });
    }
  }

  isReadyToCertify() {
    return true;
  }

  removeUser(providerPJUserId: any) {
    if (this.providerPJ.id) {
      this.profileProviderPJService
        .deleteMemberByProviderPjUserId(this.providerPJ.id, providerPJUserId)
        .subscribe(() => {
          this.providerPJ.providerPJUser =
            this.providerPJ.providerPJUser?.filter(
              (item) => item.id != providerPJUserId
            );
          this.cd.detectChanges();
          this.table.renderRows();
        });
    }
  }

  addUser() {
    const dialogRef = this.dialog.open(DialogAddUserComponent);

    dialogRef.afterClosed().subscribe((email: string) => {
      if (this.providerPJ.id && email) {
        this.profileProviderPJService
          .addMember(this.providerPJ.id, email)
          .subscribe((response) => {
            if (response) {
              this.providerPJ = response;
              this.cd.detectChanges();
              this.table.renderRows();
            }
          });
      }
    });
  }

  validateCNPJ(control: any) {
    const cnpj = control.value;
    if (cnpj && (!isValidCNPJFormat(cnpj) || !isValidCNPJ(cnpj))) {
      return { invalidCNPJ: true };
    }
    return null;
  }

  async loadAddressesByProfileProviderPJId(profileProviderPJId: number) {
    const response = await firstValueFrom(
      this.profileProviderPJService.getAllAddresses(profileProviderPJId)
    );
    this.addresses = response || [];
  }

  async createAddress(address: any) {
    address.profileProviderPJ = this.providerPJ;
    const newAddress = await firstValueFrom(
      this.profileProviderPJService.addAddress(this.providerPJ.id!, address)
    );

    if (newAddress) {
      this.addresses.push(newAddress);
    }
  }

  async deleteAddress(addressId: number) {
    const response = await firstValueFrom(
      this.profileProviderPJService.deleteAddress(this.providerPJ.id!, addressId)
    );
    this.addresses = this.addresses.filter((address) => address.id !== addressId);
    this._snackBar.open('Endereço removido com sucesso', '', {
      duration: 3000,
    });

    this.cd.detectChanges();
  }

  async setCommercialAddress(addressId: number) {
    this.profileProviderPJService.setCommercialAddress(this.providerPJ.id!, addressId).subscribe(
      (updatedAddress) => {
        this.addresses.forEach((address) => {
          address.commercial = address.id === addressId ? updatedAddress.commercial : false;
        });
      }
    );
  }

  openAddressDialog() {
    const dialogRef = this.dialog.open(AddressDialogComponent, {
      data: { addresses: this.addresses, profileProviderPJId: this.providerPJ.id }
    });

    dialogRef.afterClosed().subscribe((newAddress: any) => {
      if (newAddress) {
        this.createAddress(newAddress);
      }
    });
  }

  async editAddress(addressId: number) {
    const addressToEdit = this.addresses.find((addressfound) => addressfound.id === addressId);
    if (!addressToEdit) {
      console.error('Address not found:', addressId);
      return;
    }

    const dialogRef = this.dialog.open(AddressDialogComponent, {
      data: { address: addressToEdit }
    });

    dialogRef.afterClosed().subscribe((updatedAddress: any) => {
      if (updatedAddress) {
        this.profileProviderPJService.updateAddress(this.providerPJ.id!, addressId, updatedAddress).subscribe(
          (response) => {
            const index = this.addresses.findIndex((address) => address.id === addressId);
            if (index !== -1) {
              this.addresses[index] = response;
            }
          }
        );
      }
    });
  }

  updateUserRole(element: ProviderPJUser, newRole: string) {
    if (this.user?.email === element.user!.email && element.role === ProviderPJUser.RoleEnum.Owner) {
      this._snackBar.open('Não é possível alterar o papel do proprietário', '', {
        duration: 3000,
      });
      return;
    }

    if (this.providerPJ && this.providerPJ.id) {
      const updatedUser = {
        ...element,
        role: newRole
      };

      this.profileProviderPJService
        .updateMemberRole(this.providerPJ.id, element.user!.email, newRole as "OWNER" | "LEADER" | "MEMBER")
        .subscribe({
          next: (response) => {
            const index = this.providerPJ.providerPJUser?.findIndex(u => u.id === element.id) || -1;
            if (index !== -1 && this.providerPJ.providerPJUser) {
              this.providerPJ.providerPJUser[index] = response;
            }
            this.providerPJ = response;
            this.cd.detectChanges();
            this.table.renderRows();

            this._snackBar.open('Permissão atualizada com sucesso', '', {
              duration: 3000,
            });
          }
        });
    }
  }

  getProductTypeEnumDescription(productType: string | null) {
    if (!productType) return '';
    let typeDesc: any = ProductTypeEnumDescription[productType as keyof typeof ProductTypeEnumDescription];
    if (typeDesc) {
      return typeDesc;
    }
    return '';
  }

  isProvider() {
    return (this.packageTypeRef() ?? '').includes('PROVIDER');
  }

  packageTypeRef() {
    return this.productPackageType ?? this.providerPJ?.packageTypeRef ?? null;
  }

  private syncProfileFromPackageType() {
    if (this.providerPJForm?.controls?.['profile']?.value) return;

    const pkg = this.productPackageType;
    if (!pkg) return;

    const inferredProfile = pkg.includes('PROVIDER')
      ? 'PROVIDER_PJ'
      : (pkg.includes('CONTRACTOR') ? 'CONTRACTOR_PJ' : null);

    if (inferredProfile) {
      this.providerPJForm.controls['profile'].setValue(inferredProfile);
    }
  }

  checkCertifiedCompanyData(): boolean {
    return this.providerPJForm.controls['certifiedHubMedical'].value;
  }
  
  checkCertifiedDocuments(): boolean {
    return false;
  }

  checkCertifiedAddress(): boolean {
    return false;
  }

  isCertifiedCouncilAndProfession: boolean = false;

  checkAllCertification(): boolean {
    if (this.isCertifiedCouncilAndProfession && this.checkCertifiedDocuments()) return true;
    else return false;
  }

  refreshCertifications(): void {
    if (this.providerPJForm.controls['id'].value) {
      this.isCertifiedCouncilAndProfession = true;
      this.checkCertifiedDocuments();
    }
  }

  getPageTitle(): string {
    let type = 'PJ';
    const packageType = this.packageTypeRef();
    if (packageType?.includes('SUBSCRIPTION_PROVIDER_PJ')) type = 'Prestadores de Serviços de Saúde';
    else if (packageType?.includes('SUBSCRIPTION_CONTRACTOR_PJ')) type = 'Contratantes de Serviços de Saúde';
    else if (packageType?.includes('SUBSCRIPTION_PROVIDER_CONTRACTOR_PJ')) type = 'Prestadores e Contratantes de Serviços de saúde';
    else if (packageType?.includes('SUBSCRIPTION_ADMINISTRATOR')) type = 'Administradoras';
    else if (packageType?.includes('SUBSCRIPTION_LAB')) type = 'Laboratórios';
    else type = 'PJ';

    return `Perfil ${type}`;
  }
}

